import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';
import { TransactionExecutionState } from './state/transaction-execution.state';
import { TransactionExecutionStep } from '../enum';
import { TenderlySimulation, Transaction } from 'common';

const store = createStore(
  { name: 'transaction-execution' },
  withProps<TransactionExecutionState>({
    transaction: undefined,
    step: undefined,
    failedStep: undefined,
    isGasRelayerTx: false,
    tenderlySimulation: undefined,
  }),
);

@Injectable({ providedIn: 'root' })
export class TransactionExecutionRepository {
  step$ = store.pipe(select(({ step }) => step));
  failedStep$ = store.pipe(select(({ failedStep }) => failedStep));

  public get store() {
    return store;
  }

  public startExecution(isGasRelayerTx: boolean): void {
    store.update(state => ({
      ...state,
      transaction: undefined,
      step: TransactionExecutionStep.EXECUTE,
      failedStep: undefined,
      isGasRelayerTx: isGasRelayerTx,
      tenderlySimulation: undefined,
    }));
  }

  public setTransaction(transaction: Transaction): void {
    store.update(state => ({
      ...state,
      transaction: transaction,
      step: TransactionExecutionStep.PROCESS,
    }));
  }

  public setStep(step: TransactionExecutionStep): void {
    store.update(state => ({
      ...state,
      step: step,
    }));
  }

  public setFailedStep(step: TransactionExecutionStep | undefined): void {
    store.update(state => ({
      ...state,
      failedStep: step,
    }));
  }

  public setTenderlySimulation(tenderlySimulation: TenderlySimulation): void {
    store.update(state => ({
      ...state,
      tenderlySimulation,
    }));
  }
}
